<template>
  <b-modal
    id="modal-request-confirm-email"
    hide-footer
    centered
    :noCloseOnBackdrop="loading"
    :noCloseOnEsc="loading"
    :hideHeaderClose="loading"
    @hidden="resetModal"
  >
    <div class="col-12 d-flex flex-column align-items-center modalsTables" style="position: relative; z-index: 1;">
      <img
        class="centerImg1 mb-5"
        src="@/assets/images/icons/alert-line.svg"
        width="20%"
      />
      <p>
        Solicitar confirmación del paciente al correo
      </p>

      <div class="row mt-5 mb-5 w-100">
        <div class="col-md-12">
          <Input
            label="Email"
            name="email"
            type="email"
            :required="true"
            :value="formData.email"
            @input="(event) => (formData.email = event.target.value)"
          />
        </div>
      </div>

      <div
        class="w-100 mt-4 d-flex align-content-center justify-content-center"
      >
        <button
          class="button-send-email"
          style="color: white !important"
          :disabled="loading || !formData.email"
          @click.prevent="sendEmail()"
        >
          Enviar confirmación
          <b-spinner class="ml-2" v-if="loading" />
        </button>
      </div>
      <b-alert
        dismissible
        variant="danger"
        show
        class="mt-4"
        v-if="isError"
      >
        <p>Error en el servidor. Intente nuevamente</p>
      </b-alert>
    </div>
  </b-modal>
</template>

<script>
import useInputs from "@/components/general/Inputs";
const { Input } = useInputs();
import {
  saveAuthorization,
} from "@/services/health-tracker/saludCondition/service";
export default {
  props: {
    employee: {
      type: Object,
      default: null,
    },
    doctor_name: {
      type: String,
      default: null,
    }
  },
  components: {
    Input,
  },
  watch: {
    employee() {
      const me = this;
      me.formData.email = me.employee?.email;
    },
  },
  data() {
    return {
      formData: {
        email: "",
      },
      loading: false,
      isError: false,
    };
  },
  methods: {
    async sendEmail() {
      const me = this;
      me.loading = true;
      me.isError = false;
      try {
        const { data } = await saveAuthorization({
          email: me.formData?.email,
          doctor_name: me.doctor_name,
        });
        me.$emit("sendEmailSuccess", data);
        me.$bvModal.hide('modal-request-confirm-email')
        me.$bvModal.show('modal-success-confirm-email')
      } catch (error) {
        console.log(error);
        me.isError = true;
      } finally {
        me.loading = false;
      }
    },
    resetModal() {
      const me = this;
      me.isError = false;
    }
  },
  mounted() {
    const me = this;
    me.formData.email = me.employee?.email;
  }
};
</script>
<style>
.button-send-email {
  border: 1px solid #5d5fef;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background-color: #5d5fef;
  display: flex;
  align-items: center;
}
</style>
